import { useSetRecoilState } from "recoil";
import { taskCounterSubmissionSearchAtom } from "../miscellaneous/taskCounterSubmissionSearchAtom";

export const useSetTaskCounterSubmissionSearch = () => {
  return useSetRecoilState(taskCounterSubmissionSearchAtom);
};
